module.exports = __webpack_public_path__ + "img/pager2-quick-icon5.0cfaf709.png";